import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';
import {  MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from '../service/settings.service';
import { MatButtonModule } from '@angular/material/button';
import { CommentsService } from '../service/comments.service';
import { MatDialog } from '@angular/material/dialog';
import { ReportsItemTridyDialogComponent } from './reports-item-tridy-dialog/reports-item-tridy-dialog.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatBadgeModule, MatMenuModule, MatIconModule, MatButtonModule],
    template: `
        <button mat-icon-button (click)="openRowDialog()" class="d-flex" matTooltipPosition="above"><mat-icon>chevron_right</mat-icon></button>    
    `
})

export class ReportsListItemActionDisplay implements ICellRendererAngularComp {
    data: any;
    tridy = signal<any>(undefined);
    reportId = signal<string>(undefined)
    allTridysList:any
    allContentTypesList:any
    constructor(private router: Router, 
       private settingService:SettingsService,
        private route: ActivatedRoute,
        private commentService:CommentsService,
        public dialog: MatDialog,
    ){
        const routerUrl = this.route.url

        this.route.params.subscribe( (route_:ActivatedRoute) => {
            const contextId = this.settingService.contextId$
            this.reportId = route_['reportId']
        })
    }

    agInit(params: ICellRendererParams): void {
        this.data = params;
        this.refresh(params.data);
    }
    refresh(params: ICellRendererParams) {
        this.tridy.set(params ?? undefined);
        return true;
    }

    openRowView(){
        const id = this.data?.data?.id//this.tridy().id
        this.router.navigate(['home', this.settingService.contextId$,'reports',this.reportId , 'tridys',id])
    }

    async getContentTypes(){
        try{
          this.settingService.observeContextsContentTypesFirestoreWithId(this.settingService.contextId$).subscribe ( value => {
            this.allContentTypesList = value
          })
        }catch(error){
          console.log(error)
        }
      }

    async openRowDialog(){
        const id = this.data?.data?.id

        try{
            let dialogRef = this.dialog.open(ReportsItemTridyDialogComponent, {
                data: {
                    reportId: this.reportId,
                    idToShow: id,
                    allTridysList: this.allTridysList ?? [],
                    contentTypesList: this.allContentTypesList ?? []
                },
                disableClose: false,
                width: '800px',
                maxWidth: '90vw',
                panelClass: 'custom-dialog-container',
                position: { right: '0'},
                enterAnimationDuration: '200ms',
                exitAnimationDuration: '200ms'
                });
                dialogRef.afterClosed().subscribe(result => {});
            // })
        }catch(error){
        this.commentService.progressSpin.emit(false)
        }
    }
}